import type { ResourceArticle } from '~/types/ResourceArticle'

export const understandingSelfHarmArticle: ResourceArticle = {
  uid: 'understanding-self-harm',
  thumbnailImageUrl: 'https://cdn.hubofhope.co.uk/public/img/thumbs/RESOURCES_SH_800x800.jpg',
  thumbnailImageAlt: 'Self-harm',
  title: 'Understanding self-harm',
  supportNeedCategoryUid: 'sevcS4SYYRMARSqCE3cv',
  supportNeedCategoryLabel: 'Self-harm',
  isFeatured: true,
  excerpt:
    'Sometimes we feel so desperate that we feel like harming ourselves, for example cutting or burning ourselves, or taking toxic substances or overdoses.',
  content: `
  <div class="prose mt-4">
    <p class="font-bold">
      Sometimes we feel so desperate that we feel like harming ourselves, for example cutting or burning ourselves, or taking toxic substances or overdoses.
    </p>
  
    <p class="mt-4">
      This is often not about wanting to die – sometimes hurting ourselves can be a way of trying to cope with overwhelming emotions or extreme distress. Sometimes the distress can have its origins in things that happened when we were younger, for example abuse or neglect 
      (<a href="/resource/trauma-post-traumatic-stress" class="text-blue-500 underline hover:text-blue-700">see Trauma & post-traumatic stress</a>).
    </p>
  
    <p>
      In terms of help, we can often identify the events and circumstances that lead us to feel like self-harming, and these can often be the most helpful focus.
    </p>
  
    <figure class="my-8">
      <img src="https://cdn.hubofhope.co.uk/public/img/thumbs/pexels-alex-green-5699424_800x800.jpg"
           alt="Self-harm article image" 
           class="max-w-md w-full h-auto rounded shadow-md mx-auto">
    </figure>
  
    <h2 class="font-semibold text-lg font-brown text-primary mt-10">How to seek help</h2>
    <p class="mb-8">
      Therapy or counselling can be useful to help process difficult memories, identify triggers, minimise the likelihood of severe injury, and to find alternative ways of coping with distress, including ways of regulating our physical and emotional states. Connecting with others with similar experiences either informally or in organised peer support groups, such as the National Self-Harm Network – 
      <a href="https://www.nshn.co.uk" class="text-blue-500 underline hover:text-blue-700">https://www.nshn.co.uk</a> – can be a big help.
    </p>
  </div>`
}
